import { Link } from "gatsby"
import React from "react"
import tw from "twin.macro"

import QuickLabelLogo from "../../images/labelscape-logo.svg"
import Search from "./search"

const HeaderContainer = tw.header`container mx-auto flex flex-col md:flex-row mb-8 px-4`
const LogoContainer = tw(Link)`block h-full mt-8`
const Logo = tw.img`w-full block h-24`
const FSLink = tw.a`font-bold uppercase rounded-b-lg bg-ql-blue focus:bg-ql-bluelight hover:bg-ql-bluelight transition ease-in-out duration-300 text-white px-8 py-2 text-xs tracking-wider shadow-inner`
const Navbar = tw.div`block`
const NavbarLinkBase = tw(
  Link
)`tracking-wide uppercase text-ql-gray lg:text-sm focus:text-ql-blue hover:text-ql-blue ml-0 md:ml-4 lg:mx-4 px-4 py-2 rounded-full`
const HeaderContent = tw.div`flex-1 flex flex-col justify-between md:items-end`
const NavbarLinks = tw.div`my-4 lg:my-0 flex justify-around lg:inline-block`
const MobileOnly = tw.div`md:hidden text-right`
const NotMobile = tw.div`hidden md:block`
const SkipLink = tw.a`sr-only focus:not-sr-only fixed! top-0 left-0 p-4! text-lg text-white bg-gray-800 inline-block`

const NavbarLink = props => (
  <NavbarLinkBase
    {...props}
    partiallyActive
    activeStyle={tw`text-white bg-ql-red`}
  />
)

const Header = () => (
  <HeaderContainer>
    <div>
      <SkipLink href="#end-header">Skip to content</SkipLink>
    </div>
    <MobileOnly>
      <FSLink href="https://www.frontierscience.org">
        frontierscience.org
      </FSLink>
    </MobileOnly>
    <LogoContainer to="/">
      <Logo src={QuickLabelLogo} />
    </LogoContainer>
    <HeaderContent>
      <NotMobile>
        <FSLink href="https://www.frontierscience.org">
          frontierscience.org
        </FSLink>
      </NotMobile>
      <Navbar>
        <NavbarLinks>
          <NavbarLink to="/support">Support</NavbarLink>
          <NavbarLink to="/docs">Documentation</NavbarLink>
        </NavbarLinks>
        <Search />
      </Navbar>
    </HeaderContent>
    <div id="end-header"></div>
  </HeaderContainer>
)

export default Header
